import React, { useState } from "react";
import faqsData from "./faqs.json";
import ScrollToTopOnMount from "../../scrollComponents/ScrollToTopOnRoute";

const FAQ = () => {
  const foundingYear = 2020;
  const currentYear = new Date().getFullYear();
  const yearsInBusiness = currentYear - foundingYear;

  const faqsWithDynamicYears = faqsData.map((faq) => {
    if (faq.question === "How long has S&J been in business?") {
      return {
        ...faq,
        answer: `S&J has been in business for ${yearsInBusiness} ${yearsInBusiness === 1 ? "year" : "years"}.`,
      };
    }
    return faq;
  });

  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className="px-6 py-12 max-w-4xl mx-auto">
		<ScrollToTopOnMount/>
      <h2 className="text-3xl md:text-4xl font-[Lora] font-bold text-[#2c7b2f] text-center mb-10">
        Frequently Asked Questions
      </h2>

      <div className="space-y-4">
        {faqsWithDynamicYears.map((faq, idx) => (
          <div
            key={idx}
            className="border border-gray-200 rounded-xl shadow-sm overflow-hidden"
          >
            <button
              onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
              className="w-full text-left px-6 py-4 bg-[#d6e9c6] hover:bg-[#cde0b9] transition-colors duration-300 flex justify-between items-center font-bold text-[#2f4f2f]"
            >
              {faq.question}
              <span className="ml-2 text-xl">
                {openIndex === idx ? "−" : "+"}
              </span>
            </button>
            {openIndex === idx && (
              <div className="px-6 py-4 bg-white text-gray-700 transition-all duration-300">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
